/* eslint-disable */ 
jQuery(document).ready(($) => {
    /* Toggle Menu Functionality */
    $("#sbs-nav > ul > li.menu-item-has-children").append('<div class="toggle-arrow"><div class="sub-menu-icon"></div></div>')
    $('.header__navigation-toggle').on('click',() => {
      $(".header__navigation").toggleClass("header__navigation-active");
      $('.search_overlay').removeClass("active");
      $(".header__navigation-toggle").toggleClass("active");
      $('body').toggleClass("filter-overlay");
    });
  
    $('.header__icons').on('click',() => {
        setTimeout(function(){
          $('#s').focus();
        });
        $('.search_overlay').toggleClass("active");
        $(".header__navigation-toggle").removeClass("active");
        $(".header__navigation").removeClass("header__navigation-active");
        $('body').toggleClass("filter-overlay");
        $('.mobile-nav').hide();
    });

    $(".search_overlay__input__search").click(function(){
      $("#searchform").submit();
    })

    $('.search_overlay').on('click', '.search_overlay__search', function() {
      $("#searchform").submit();
    });

    $('.search_overlay__input__text').keyup(function(){
      if($(this).val().length >= 3){
        $.ajax({
          url: script_object.ajax_url,
          data:{action:'suggestions', search: $(this).val()},
          type:'POST',
          success:function(result){
            $('.search_overlay__suggestions').html(result);
          },
          error: function(result)
          {
              //console.log("error:"+ result);
          }
        })
      }else{
        $('.search_overlay__suggestions').html('');
      }
    })
  
    $('.search_overlay__input__close').on('click',() => {
        $('.search_overlay').toggleClass("active");
        $('body').toggleClass("filter-overlay");
        $('.mobile-nav').show();
        $('.search_overlay__input__text').val('');
        $('.search_overlay__suggestions').html('');
    });

    $(".filter-overlay").ontouchmove = function (e) {
      e.preventDefault();
    }    

    $("#search-submit").on("click", function(e){
      if($(".header__searchform-input").val().length >= 3){
        $('.header__container .header__search-error').remove();
      }else{
        e.preventDefault();
        append_error_msg();
      }
    })
  
    $('.header__searchform-input').on('keypress', function (e) {
      $(this).val($(this).val());
      /* MIN and MAX charcter length */
      var e_len = $(this).val().length;
      if (e_len >= 2) {
        $('.header__container .header__search-error').remove();
      }
      if (e.which === 13) {
        if (e_len <= 2) {
          append_error_msg();
          e.preventDefault();
        }
      }
  });
  
    function append_error_msg() {
      $('.header__container .header__search-error').remove();
      $('.header__container').append('<div class="header__search-error"><div class="header__search-error__content">Vennligst søk med minst 3 tegn for å generere søkeresultater.<i class="fa fa-times-circle" aria-hidden="true"></i></div></div>');
    }
  
    function isTouchDevice() {
      if (window.matchMedia('(max-width: 1200px)').matches) {
        return true;
      }
      return false;
    }
  
    if(isTouchDevice()) {
      // eslint-disable-next-line func-names
      $(".toggle-arrow").click(function (event) {
        $(this).parent().toggleClass("clicked");
        $("#sbs-nav > ul > li.menu-item-has-children").not($(this).parent()).removeClass("clicked");
      });
    }  

    if (window.location.href.indexOf("Iframe") > -1) {
      $('html, body').animate({
        scrollTop: $('#gameFrame').offset().top - 100
      }, 'slow');
    }
  });
  